import { render, staticRenderFns } from "./EditMerkBarang.vue?vue&type=template&id=7698b159&"
import script from "./EditMerkBarang.vue?vue&type=script&lang=js&"
export * from "./EditMerkBarang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports